import { CSSObject } from '@emotion/react'
import { sharedColors } from './colors'

const accountWidth: CSSObject = {
  desktopSingle: '190px',
  desktopStream: '510px',
  mobileStream: '285px',
}

const headerLayout: CSSObject = {
  boxSizing: 'border-box',
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  '*': {
    boxSizing: 'border-box',
  },
}

const accountPosition = (
  shouldShiftUp: boolean,
  display: string
): CSSObject => ({
  paddingBlockEnd: shouldShiftUp ? '20px' : 0,
  fontWeight: 700,
  inlineSize: `${accountWidth[display]}`,
  overflow: 'hidden',
  textAlign: 'start',
})

const locationPosition: CSSObject = {
  insetInlineStart: 44,
  position: 'absolute',
  insetBlockStart: 20,
}

const responseList: CSSObject = {
  display: 'flex',
  listStyleType: 'none',
  padding: 0,
}

type ResponseItemProps = {
  bookmark?: boolean
}

const responseItem = ({ bookmark = false }: ResponseItemProps): CSSObject => ({
  marginInlineStart: bookmark ? 'auto' : 0,
  '.kuiper-icon': {
    blockSize: 21,
    marginInlineEnd: bookmark ? 0 : 17,
    inlineSize: 21,
  },
})

const addCommentText: CSSObject = {
  borderBlockStart: `solid 1px ${sharedColors.horizontalBorderColor}`,
  color: `${sharedColors.mediumGreyText}`,
  fontSize: 15,
  padding: 24,
}

const accountMeasurer: CSSObject = {
  insetInlineStart: 5,
  lineHeight: '28px',
  position: 'absolute',
  insetBlockStart: 0,
}

const collabAvatarStyles: CSSObject = {
  height: '34px',
  width: '34px',
  div: {
    display: 'block',
  },
  'div:nth-of-type(2)': {
    marginLeft: '10px',
    marginTop: '-14px',
    display: 'block',
    position: 'absolute',
  },
}

const secondAvatarStyles: CSSObject = {
  backgroundColor: 'rgb(208, 218, 225)',
}

const postedAt: CSSObject = {
  color: `${sharedColors.mediumGreyText}`,
  fontSize: 10,
  fontWeight: 600,
  textTransform: 'uppercase',
}

const sharedStyles = {
  accountMeasurer,
  accountPosition,
  addCommentText,
  collabAvatarStyles,
  headerLayout,
  locationPosition,
  postedAt,
  responseItem,
  responseList,
  secondAvatarStyles,
}

export { sharedColors, sharedStyles }
